import React from 'react';
import {LoadingIndicator} from '@spotify-internal/encore-web';

import styles from './LoadingSpinner.module.scss';

const LoadingSpinner = () => (
  <div className={styles.loadingSpinnerContainer}>
    <LoadingIndicator />
  </div>
);

export default LoadingSpinner;
